import { render, staticRenderFns } from "./ImagesLABNonRecently.vue?vue&type=template&id=71995c58&scoped=true"
import script from "./ImagesLABNonRecently.vue?vue&type=script&lang=js"
export * from "./ImagesLABNonRecently.vue?vue&type=script&lang=js"
import style0 from "./ImagesLABNonRecently.vue?vue&type=style&index=0&id=71995c58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71995c58",
  null
  
)

export default component.exports